"use strict";
var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
/**
 * Apparitions légères au scroll (fade + léger décalage vertical).
 */
var revealSelectors = [
    '.carousel-header .content',
    '#top-footer .wp-block-image',
    '#top-footer .wp-block-buttons',
];
var revealEls = Array.from(document.querySelectorAll(revealSelectors.join(',')));
if (revealEls.length) {
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealEls.forEach(function (el) { return el.classList.add('reveal-in'); });
    }
    else {
        revealEls.forEach(function (el, i) {
            el.classList.add('reveal');
            el.style.transitionDelay = "".concat(Math.min(i, 3) * 90, "ms");
        });
        var observer_1 = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('reveal-in');
                    observer_1.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
        revealEls.forEach(function (el) { return observer_1.observe(el); });
    }
}
/**
 * Léger parallaxe : le logo au-dessus du footer se déplace légèrement plus
 * lentement que le reste au scroll.
 *
 * Le hero avait le même traitement au départ, mais même réduite (±25px puis
 * ±10px), l'amplitude continuait à rogner le bas de l'image ronde contre les
 * bords de son cadre selon le point de défilement — retiré plutôt que
 * continuer à deviner une valeur sûre sans pouvoir vérifier la marge réelle
 * de l'image source.
 */
if (!prefersReducedMotion) {
    var footerLogo_1 = document.querySelector('#top-footer .wp-block-image img');
    if (footerLogo_1) {
        var ticking_1 = false;
        var clamp_1 = function (value, min, max) {
            return Math.max(min, Math.min(max, value));
        };
        var update_1 = function () {
            ticking_1 = false;
            var rect = footerLogo_1.getBoundingClientRect();
            if (rect.bottom >= 0 && rect.top <= window.innerHeight) {
                var viewportCenter = window.innerHeight / 2;
                var elCenter = rect.top + rect.height / 2;
                var offset = clamp_1((viewportCenter - elCenter) * 0.06, -18, 18);
                footerLogo_1.style.transform = "translateY(".concat(offset, "px)");
            }
        };
        var onScroll = function () {
            if (!ticking_1) {
                ticking_1 = true;
                requestAnimationFrame(update_1);
            }
        };
        update_1();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
    }
}
